import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { SettingsConstants } from 'projects/is-ui-kit/src/lib/core/settings/settings.service';

export const LoginAuthGuard: CanActivateFn = (): boolean => {
  const cookieService = inject(CookieService);

  const token = cookieService.get('token');
  const avoidLogin = SettingsConstants.AVOIDLOGIN;

  if (!token) {
    if (avoidLogin) {
      location.href = `${SettingsConstants.BACKENDURL}${SettingsConstants.LOGINURL}`;
      return false;
    } else {
      return true;
    }
  }

  return true;
};
